import orange from '@material-ui/core/colors/orange'

const styles = {
    errorStyle: {
      color: orange,
    },
    underlineStyle: {
      borderColor: orange,
    },
    floatingLabelStyle: {
      color: orange
    },
    floatingLabelFocusStyle: {
      color: orange,
    },
    checkboxLabel: {
        width: '100%'
    }
};

export default styles;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/styles.js